import { useHistory, Link as RouterLink } from 'react-router-dom'

import { PlanName } from '@tribeplatform/gql-client/types'
import { useNetwork } from '@tribeplatform/react-sdk/hooks'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { Card } from '@tribeplatform/react-ui-kit/Card'
import { Link } from '@tribeplatform/react-ui-kit/Link'

import { PlanCard } from '../Plans/PlanCard'
import { BillingDetailsCard } from './BillingDetailsCard'
import { PaymentMethodCard } from './PaymentMethodCard'
import { PaymentsCard } from './PaymentsCard'

export const BillingPage = () => {
  const history = useHistory()
  const { data: network } = useNetwork()

  if (
    network?.subscriptionPlan?.trial ||
    network?.subscriptionPlan?.name === PlanName.BASIC
  ) {
    history.replace('/manage/settings/billing/plans')
    return null
  }

  return (
    <div className="flex flex-col space-y-5">
      <PlanCard />
      <Card>
        <Card.Header
          title="Seats"
          action={
            <Button
              variant="outline"
              type="button"
              onClick={() => history.push('/manage/settings/billing/purchase')}
            >
              Change
            </Button>
          }
        />
        <Card.Content>
          You have <b>{network?.seatsCapacity} seats</b>,{' '}
          {network?.seatsCapacity - network?.seatCapacityDeclared} of them
          currently unused.{' '}
          <Link as={RouterLink} to="/manage/settings/billing/purchase">
            Manage teammates
          </Link>
        </Card.Content>
      </Card>
      <PaymentMethodCard />
      <BillingDetailsCard />
      <PaymentsCard />
    </div>
  )
}
